import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../StateManagement/actions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSButton from "../../Components/Button/WSButton";
import WSFilterButtonGroup from "../../Components/Filter/WSFilterButtonGroup";
import AddIcon from '@mui/icons-material/Add';
import { updateMainHeader } from "../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";

export const SaleInvoiceList: React.FC<any> = React.memo((props) => {
    const navigate = useNavigate();
    const [selectedId, setSelectedId] = useState<string | number>(0);
    const [isPopupOpen, setPopupOpen] = useState(false);

    const dispatch = useDispatch();
    const { showMessage } = useSnackbar();

    const filters = ['All Records'];
    const [selectedFilter, setSelectedFilter] = useState(filters[0]);

    const source = {
        url: "Vyapar/SaleInvoice/search",
        page: 1,
        pageSize: 10,
        filter: [],
        sort: [],
    };

    useEffect(() => {
        updateMainHeader('Category');
    })

    breadCrumbsStore.updateBreadCrumbs([
        { 'Sale List': '/sale/list' },
    ]);

    const handleFilter = (value: any) => {
        let soureFilter: any = {
            url: "Vyapar/SaleInvoice/search",
            page: 1,
            pageSize: 10,
            filter: [
            ],
            sort: [
                {
                    "field": "UpdatedAt",
                    "direction": "desc"
                }
            ],
        }
        switch (value) {
            case 'In Stock':
                soureFilter.filter = [{
                    "field": "name",
                    "operator": "eq",
                    "value": "In Stock"
                }]
                break

        }
    }


    const handleAction = (action: string, row: { customerName: string, id: number }) => {

        if (action === "Edit") {
            navigate(`/sale/${row.id}`);
        } else if (action === "Delete") {
            setSelectedId(row.id);
            setPopupOpen(true);
        }
    };

    const columns: IColumns[] = [
        {
            header: "Name",
            fieldName: "customerName",
        },

        {
            header: "Phone",
            fieldName: "phoneNumber",
        },

        {
            header: "Invoice No",
            fieldName: "invoiceNo",
        },

        {
            header: "Invoice Date",
            fieldName: "invoiceDate",
            type: "date"
        },

        {
            header: "Phone",
            fieldName: "phoneNumber",
        },

        {
            header: "Total Amount",
            fieldName: "total",
        },

        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: ["Edit", "Delete"],
            actionCallback: handleAction,
        },
    ];

    const handleClick = () => {
        navigate("/sale");
    };

    return (
        <Grid p={3}>
            <Grid container spacing={2}>
                <Grid item sm={9}>
                    <WSFilterButtonGroup options={filters} selected={selectedFilter}
                        onChange={(value) => {
                            setSelectedFilter(value);
                            handleFilter(value);
                        }} />
                </Grid>
                <Grid item sm={3} display="flex" justifyContent={'flex-end'}>
                    <WSButton id="btnAddNewSale" label="Add Sale" startIcon={<AddIcon />}
                        onClick={handleClick}
                        sx={{
                            borderRadius: '999px',         // pill shape
                            backgroundColor: '#098963!important',    // green background
                            textTransform: 'none',         // prevent uppercase
                            fontWeight: 500,
                            height: '35px!important',
                            fontSize: '0.875rem!important',
                            paddingX: 3,
                            paddingY: 1,
                            '&:hover': {
                                backgroundColor: '#087654!important',
                            },
                        }} />
                </Grid>
                <Grid item xs={12}>
                    <WSDataGrid
                        id="saleGrid"
                        title="Sale"
                        columns={columns}
                        source={source}
                        searchBox={{ fieldName: 'name' }}
                        addButton={{ label: "New", color: "secondary" }}
                        onAddButtonClick={handleClick}
                        gridHeaderSx={{
                            backgroundColor: "whitesmoke",
                            border: "1px solid whitesmoke",
                        }}
                    />
                </Grid>

                <ConfirmationPopup
                    type="DELETE"
                    apiUrl="Vyapar/SaleInvoice"
                    id={selectedId}
                    confirmMessage="Are you sure you want to delete this sale invoice?"
                    open={isPopupOpen}
                    onClose={() => setPopupOpen(false)}
                    onConfirm={(data: any) => {
                        dispatch(resetDataComponent("saleGrid"));
                        if (data.success === true) {
                            showMessage(data?.message, "success");
                        } else {
                            showMessage(data?.message, "error");
                        }
                    }}
                />

            </Grid>
        </Grid>
    );
});
